/**
 * Class that describes the shape of the EOD Report.
 */
export class ReportTemplate {
  id: number;
  displayName: string;
  value: string;
  children?: {
    displayName: string;
    editable?: boolean;
    value: string;
    total?: number;
    parentId?: string;
    childrenFormula?: { hasFormula?: boolean; formula?: string }[]
  }[];
}
